"use client";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { createClient } from "@/lib/supabase-client";
import { ArticleCard } from "./ArticleCard";

interface RelatedArticlesProps {
  currentArticleId: string;
  locale: string;
}

export function RelatedArticles({
  currentArticleId,
  locale,
}: RelatedArticlesProps) {
  const t = useTranslations("blog");

  const [articles, setArticles] = useState<any[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fetchRelatedArticles = async () => {
      try {
        const supabase = createClient();

        const { data, error } = await supabase
          .from("articles")
          .select("*")
          .eq("language", locale)
          .neq("id", currentArticleId)
          .order("created_at", { ascending: false })
          .limit(2);

        if (error) {
          return;
        }

        if (data) {
          setArticles(data);
        }
      } catch (error) {}
    };

    const handleScroll = () => {
      const scrolled = window.scrollY;
      const viewportHeight = window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
      const scrollPercentage = scrolled / (totalHeight - viewportHeight);

      if (scrollPercentage > 0.6) {
        setIsVisible(true);
        window.removeEventListener("scroll", handleScroll);
        fetchRelatedArticles();
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentArticleId, locale]);

  if (!isVisible || articles.length === 0) {
    return null;
  }

  return (
    <div className="mt-12">
      <h3 className="text-3xl sm:text-4xl font-bold mb-6 text-center">
        {t("more")}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            article={article}
            locale={locale}
            className="max-w-xl"
          />
        ))}
      </div>
    </div>
  );
}
